import React from 'react'

function DrawDownDesc() {
  return (
    <div>


<b>Allows reinvesting and growing your retirement fund</b><br/>

The funds are invested in a guaranteed fund where they continue to grow as you access an income.<br/>

<b>Ability to choose your income</b><br/>

Every year you can choose to access any amount up to a maximum of 15% of lump sum deposited as long as your fund will run for a minimum of 10 years.<br/>

<b>Allows flexibility on frequency of income</b><br/>

You can choose not to access any income until a later date or you can vary the frequency of accessing the benefits every year to suit your income needs.<br/>

<b>Enables you to purchase an annuity at a later date</b><br/>

After expiry of 10 years you can choose to purchase an annuity which will provide you with an income for life.<br/>

<b>Allows you to leave an inheritance to your beneficiaries.</b><br/>

You can choose to leave part or your entire fund to your loved ones.<br/>





    </div>
  )
}

export default DrawDownDesc